export enum Clubhouse_LeagueType {
  TEAM = "TEAM",
  INDIVIDUAL = "INDIVIDUAL",
  SCRAMBLE = "SCRAMBLE",
}

export enum Clubhouse_LeagueScoring {
  STROKE = "STROKE",
  MATCH = "MATCH",
  POINTS = "POINTS",
}

export enum Clubhouse_LeagueHandicapMethod {
  NET = 1,
  GROSS = 2,
}

export enum Clubhouse_LeagueFacilityScope {
  THIS_FACILITY = "THIS_FACILITY",
  ANY_OF_MY_FACILITIES = "ANY_OF_MY_FACILITIES",
}

export enum Clubhouse_TeamPlayFormat {
  FOUR_BALL = 1,
  SCRAMBLE = 2,
}

export enum Clubhouse_MatchPlayStyle {
  AD_HOC = 0,
  ROUND_ROBIN = 1,
  BRACKETS = 2,
}

export enum Clubhouse_MatchPlayAssignment {
  MANUAL = 0,
  AUTOMATIC = 1,
}

export enum Clubhouse_TeamPlayStyle {
  AS_TEAM = 0,
  AS_FLIGHT = 1,
}
export enum Clubhouse_SideContestType {
  ClosestToPin = 1,
  LongDrive = 2,
  Skins = 3,
}
export enum Clubhouse_LgStrokePlayAggregation {
  CUMULATIVE = "CUMULATIVE",
  AVERAGE = "AVERAGE",
  BEST_N = "BEST_N",
}
export enum Clubhouse_LgStrokePlayRanking {
  TOTAL_TO_PAR = "TOTAL_TO_PAR",
  AVERAGE = "AVERAGE",
  TOTAL_POINTS = "TOTAL_POINTS",
}
export enum Clubhouse_LgStrokePlayTieHandling {
  SHARED = "SHARED",
  TIEBREAKER = "TIEBREAKER",
}
export enum Clubhouse_LgStrokePlayMaxScorePolicy {
  DOUBLE_PAR = "DOUBLE_PAR",
  TRIPLE_BOGEY = "TRIPLE_BOGEY",
  CUSTOM = "CUSTOM",
}
export enum Clubhouse_LgMatchPlayScoringMode {
  HEAD_TO_HEAD = "HEAD_TO_HEAD",
  HOLE_BY_HOLE = "HOLE_BY_HOLE",
}
export enum Clubhouse_LgPointsLeagueMode {
  STABLEFORD = "STABLEFORD",
  CUSTOM_TABLE = "CUSTOM_TABLE",
}
export enum Clubhouse_LeagueWizardScheduleMode {
  WeeklyRounds = "WeeklyRounds",
  SeasonFlex = "SeasonFlex",
}

export enum Clubhouse_LeagueV2Status {
  DRAFT = "DRAFT",
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

export enum Clubhouse_LeaguePointRuleFormatFamily {
  INDIVIDUAL = 1,
  TEAM = 2,
  SCRAMBLE = 3,
}

export enum Clubhouse_LeagueOperatorLifecycleStatus {
  DRAFT = 0,
  OPEN = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
}

export enum Clubhouse_LgRoundStatusV2 {
  Scheduled = "Scheduled",
  Open = "Open",
  InProgress = "InProgress",
  Completed = "Completed",
  Finalized = "Finalized",
}

export enum Clubhouse_LgAdjudicationIssueTypeV2 {
  UNKNOWN = 0,
  MISSING_SCORECARD = 1,
  WRONG_COURSE = 2,
  DUPLICATE_SAVEGAME = 3,
  INVALID_SCORECARD = 4,
  ROUND_DATA_MISMATCH = 5,
  IMPORT_VALIDATION = 6,
  /** Scorecard linked by orphan recovery — requires operator verification before finalize (CLUB-2196). */
  ORPHAN_RECOVERY = 7,
}

// Scope for lg_adjudication_issues.issue_scope (V2.2 persisted contract).
export enum Clubhouse_LgAdjudicationIssueScopeV2 {
  LEAGUE = 0,
  ROUND = 1,
  PARTICIPANT = 2,
  TEAM = 3,
}

// Severity for lg_adjudication_issues.severity (V2.2 ERD).
export enum Clubhouse_LgAdjudicationIssueSeverityV2 {
  Info = "Info",
  Warning = "Warning",
  Blocking = "Blocking",
}

export enum Clubhouse_LgRoundParticipationStatusV2 {
  Scheduled = "Scheduled",
  Withdrawn = "Withdrawn",
  InProgress = "InProgress",
  Played = "Played",
}

export enum Clubhouse_LgRoundScorecardStatusV2 {
  None = "None",
  Pending = "Pending",
  Unlinked = "Unlinked",
  Linked = "Linked",
  ManualReviewRequired = "ManualReviewRequired",
}

// Where a card's hole scores came from (`scorecardSource` on the participant).
// Linkage state and provenance are separate: an operator edit leaves the card
// Linked and only moves this.
export enum Clubhouse_LgScorecardSourceV2 {
  Linked = "Linked",
  Edited = "Edited",
  Manual = "Manual",
}

// Operator actions from participant-level scorecard review. Values are the
// numeric enum members serialized as strings — the API's documented wire form
// (`{"action":"0"}`), matching the leagues numeric-as-string enum convention.
export enum Clubhouse_LgScorecardReviewActionV2 {
  LinkScorecard = 0,
  RejectScorecard = 1,
  MarkPlayedNoScorecard = 2,
  MarkNoShow = 3,
  ClearNoShow = 4,
}

export enum LeguesGender {
  MALE = "M",
  FEMALE = "F",
}

export enum LeguesHandedness {
  RIGHT = "R",
  LEFT = "L",
}

export enum AutoConcede {
  OFF = 0,
  DOUBLE_PAR = 1,
  TEN_STROKES = 2,
  BOGEY = 3,
  DOUBLE_BOGEY = 4,
  TRIPLE_BOGEY = 5,
}
export enum AutoContinue {
  OFF = 0,
  ONE_SECOND = 1,
  FOUR_SECONDS = 4,
  SEVEN_SECONDS = 7,
  TEN_SECONDS = 10,
  FIFTEEN_SECONDS = 15,
  INSTANT = -1,
}
export enum AutoGimme {
  OFF = 0,
  ONESTROKE = 1,
  TWOSTROKE = 2,
  THREESTROKE = 3,
}
export enum GimmeDistance {
  OFF = 0,
  THREE = 1,
  SIX = 2,
  NINE = 3,
  TWELVE = 4,
}
export enum HandicapMode {
  ABSOLUTE = 0,
  RELATIVE = 1,
  OFF = 2,
  PLAYER = 3,
}
export enum HandicapPercentage {
  ONE_HUNDRED = 100,
  NINETY = 90,
  EIGHTY = 80,
  SEVENTY = 70,
}
export enum PinType {
  NOVICE = 0,
  INTERMEDIATE = 1,
  ADVANCED = 2,
}
export enum ScoringType {
  STROKE = 0,
  MATCH = 1,
  SCRAMBLE = 7,
  LONG_DRIVE = 9,
  CLOSEST_TO_PIN = 10,
  STABLEFORD = 11,
  CUSTOM_STROKE = 12,
  DRILLS_STROKE = 13,
  MATCH_NASSAU = 1001,
  MATCH_SCOTCH_FOURSOME = 1002,
}
export enum WindSpeed {
  CALM = 0,
  LIGHT = 1,
  MODERATE = 2,
  STRONG = 3,
  VERY_STRONG = 4,
  OFF = 5,
  FIVE_MPH_STEADY = 6,
  TEN_MPH = 7,
  FIFTEEN_MPH = 8,
  TWENTY_MPH = 9,
  TWENTY_FIVE_MPH = 10,
  THIRTY_MPH = 11,
  THIRTY_FIVE_MPH = 12,
}
export enum TeeType {
  RED = 0,
  WHITE = 1,
  BLUE = 2,
  BLACK = 3,
  GOLD = 4,
  JUNIOR = 5,
  SKILL = 6,
  CUSTOM = 7,
  MEMBER = 8,
}
/**
 * The roster's string form of TeeType. The read side (GET /roster) returns
 * these names; the write side takes the numeric TeeType. Conversion between
 * them relies on the two enums carrying identical member names — the
 * assertions below make that a build error instead of a comment.
 */
export enum RosterTeeType {
  RED = "RED",
  WHITE = "WHITE",
  BLUE = "BLUE",
  BLACK = "BLACK",
  GOLD = "GOLD",
  JUNIOR = "JUNIOR",
  SKILL = "SKILL",
  CUSTOM = "CUSTOM",
  MEMBER = "MEMBER",
}

// Parity between the two tee enums, enforced in both directions: every TeeType
// member must exist on RosterTeeType valued as its own name, and RosterTeeType
// must add nothing TeeType lacks. Drift either way is silent data loss at
// runtime (an unnameable tee, or a save that cannot map one), so it fails here.
type TeeTypeName = Exclude<keyof typeof TeeType, number>;
const _rosterCoversTeeType: { [K in TeeTypeName]: K } = RosterTeeType;
const _rosterAddsNothing: Record<keyof typeof RosterTeeType, TeeTypeName> =
  RosterTeeType;
void _rosterCoversTeeType;
void _rosterAddsNothing;
export enum GroundConditions {
  VERY_DRY = 1,
  DRY = 2,
  NORMAL = 0,
  WET = 3,
  VERY_WET = 4,
}
export enum SkyConditions {
  SUNNY = 0,
  MOSTLY_SUNNY = 1,
  MOSTLY_CLOUDY = 2,
  CLOUDY = 3,
  FOG = 4,
}
export enum TimeOfDay {
  TIME_MORNING = 0,
  TIME_AFTERNOON = 1,
  TIME_DUSK = 2,
  TIME_NIGHT = 3,
  TIME_NONE = 4,
}
export enum WindDirection {
  NORTH = 270,
  NORTHEAST = 225,
  EAST = 180,
  SOUTHEAST = 135,
  SOUTH = 90,
  SOUTHWEST = 45,
  WEST = 0,
  NORTHWEST = 315,
}

// ── Leagues V2 scoring / standings enums ────────────────────────────────────
// NOTE: these arrive from the API as numeric-as-string ("0","1",…). Decode via
// standingsMapping.ts, never by direct comparison to a raw wire value.
//
// Clubhouse_LeagueScoringFormatV2 is the exception on both counts: it is a
// STRING enum, and its legacy wire codes are 1/2/3 rather than 0-based. It has
// no reverse map, so standingsMapping's decodeEnum cannot read it — decode it
// through components/scoringFormat.ts instead.

export enum Clubhouse_LeagueScoringFormatV2 {
  STROKE_PLAY = "STROKE_PLAY",
  MATCH_PLAY = "MATCH_PLAY",
  POINTS_LEAGUE = "POINTS_LEAGUE",
}

export enum Clubhouse_LeagueV2StandingsStatus {
  CURRENT = 0,
  STALE = 1,
  NEEDS_RECALCULATION = 2,
  NOT_SCORED = 3,
}

export enum Clubhouse_LeagueV2StandingsMovement {
  NONE = 0,
  UP = 1,
  DOWN = 2,
}

// Standings entity scope — DISTINCT from the round-results entity scope below.
export enum Clubhouse_LgStandingEntityScopeV2 {
  UNKNOWN = 0,
  MEMBER = 1,
  TEAM = 2,
}

// Round-results entity scope — PLAYER/TEAM (1/2). Do not merge with the
// standings scope enum: same field name, different meaning and values.
export enum Clubhouse_LeagueV2RoundResultEntityScope {
  PLAYER = 1,
  TEAM = 2,
}

export enum Clubhouse_LeagueV2RoundResultsScoringStatus {
  NOT_AVAILABLE = 0,
  MISSING = 1,
  NEEDS_RECALCULATION = 2,
  STALE = 3,
  SCORED = 4,
}

export enum Clubhouse_LeagueV2RoundMatchResultDisplay {
  WIN = 1,
  LOSS = 2,
  TIE = 3,
}

export enum Clubhouse_LeagueSideContestTypeV2 {
  ClosestToPin = 1,
  LongDrive = 2,
  Skins = 3,
}

export enum Clubhouse_LgMatchTypeV2 {
  HeadToHead = 0,
  VsCourse = 1,
}

export enum Clubhouse_LgMatchResultCodeV2 {
  SideAWon = 1,
  SideBWon = 2,
  Tied = 3,
}

// Recalculate result enums — these serialize as BARE integers (unlike the
// numeric-as-string scoring enums).
export enum Clubhouse_LeagueV2RoundScoringRecalculateStatus {
  COMPLETED = 0,
  BLOCKED = 1,
  SKIPPED = 2,
  FAILED = 3,
}

export enum Clubhouse_LeagueV2RoundScoringOutcomeKind {
  Applied = 0,
  SkippedRoundMissing = 1,
  SkippedAlreadyScored = 2,
  SkippedNotFinalized = 3,
  SkippedMissingScoringPolicy = 4,
  SkippedNoLinkedScorecards = 5,
  SkippedNoResults = 6,
}

// Handicap history (numeric-as-string on the wire; decode via Number()).
export enum Clubhouse_LeagueV2HandicapSourceV2 {
  Unknown = 0,
  Seed = 1,
  RosterCurrent = 2,
  Calculated = 3,
  ManualOverride = 4,
  Import = 5,
  AdminCorrection = 6,
  RoundSnapshot = 7,
  ProvisionalCalculated = 8,
}

export enum Clubhouse_LeagueV2HandicapEstablishmentStatusV2 {
  Unknown = 0,
  Seeded = 1,
  Provisional = 2,
  Established = 3,
}

export enum Clubhouse_LeagueV2HandicapExplanationTypeV2 {
  Calculated = 0,
  Imported = 1,
  Override = 2,
  Correction = 3,
  Sourced = 4,
  Seed = 5,
  Unavailable = 6,
  Provisional = 7,
}

/** How the current aG Handicap was averaged. Matches the API string names. */
export enum Clubhouse_LeagueV2HandicapCalculationRuleV2 {
  SINGLE = 0,
  AVERAGE_ALL = 1,
  LOWEST_4 = 2,
  LOWEST_4_OF_8 = 3,
}

/** Why a timeline row exists. Manual changes are not produced. */
export enum Clubhouse_LeagueV2HandicapChangeTypeV2 {
  STARTING = 0,
  CALCULATED = 1,
}

/** One player's status on a league round, for the rounds column. */
export enum Clubhouse_LeagueV2PlayerRoundStatusV2 {
  UPCOMING = 0,
  IN_PROGRESS = 1,
  PLAYED = 2,
  SKIPPED = 3,
}

/** Why a score is not a qualifying handicap input. */
export enum Clubhouse_LeagueV2HandicapExclusionReasonV2 {
  NON_QUALIFYING_HOLES = 0,
  INCOMPLETE_CARD = 1,
  NOT_ELIGIBLE_SOURCE = 2,
}

/** Which nine a 9-hole qualifying score used. */
export enum Clubhouse_LeagueV2NineHoleSideV2 {
  FRONT = 0,
  BACK = 1,
}
